export const LOGGER_MESSAGES = {
  ENVIRONMENT_DETECTION_FAILED: 'Failed to detect environment for logger.',
  ADAPTER_INIT_FAILED: 'Failed to initialize adapter',
  ADAPTER_ERROR: 'Logger adapter error',
  NO_ADAPTERS: 'Logger has no adapters configured for the current environment.',
  RUNTIME_NOT_CONFIGURED: 'Logger runtime dependencies are not configured. Ensure runtime bootstrap runs before logging.',
  GLOBAL_HANDLERS_SETUP_FAILED: 'Failed to set up global error handlers',
} as const;
